import { Account } from '../../Model/Account';
import { AccountRepository, CreateAccountDTO } from '../Repositories/AccountRepository';
import { mapCreateOrUpdateAccountError } from './AccountErrors';
import { ok, err, Result } from 'neverthrow';
import { User } from '../../../User/Model/User';

export class UpdateAccountUseCase {
  constructor(private readonly repo: AccountRepository) {}

  execute(id: number, dto: Partial<CreateAccountDTO>, current: User): Promise<Result<Account, string>> {
    // 등급 변경은 어드민만 가능
    if (dto.grade != null && current.grade !== 'ADMIN') {
      return Promise.resolve(err<Account, string>('권한이 없습니다.'));
    }
    return this.repo
      .updateAccount(id, dto)
      .then(res => ok<Account, string>(res))
      .catch(e => err<Account, string>(mapCreateOrUpdateAccountError(e).message));
  }
}
